import * as angular from 'angular';
import { NavbarDirective } from './navbarDirective/NavbarDirective';
import { TenantMenuComponent } from './tenantMenu/tenantMenu.component';
import { DefaultHeaderComponent } from './defaultHeader/defaultHeader.component';
import { TenantsListComponent } from './tenantsList/tenantsList.component';
import { MainNavbarComponent } from './mainNavbarComponent/mainNavbar.component';
import { UserMenuComponent } from './userMenu/userMenu.component';
import { react2angular } from 'react2angular';
import UserMenuReact from './userMenu/UserMenuReact';
import NotificationsCenterReact from 'modules/ui/notificationsCenter/notificationCards/NotificationsCenterReact';
import NavBarReact from './mainNavbarComponent/NavBarReact';
export default angular
    .module('navbar', [])
    .component('tenantMenu', TenantMenuComponent)
    .component('navBarReact', react2angular(NavBarReact, ['user'], [
    'SegmentService',
    'TenantService',
    'ContextProcessorService',
    '$translate',
    '$location',
    '$state',
    'BLIP_DOMAIN',
    'BlipService',
    'AccountService2',
    'OnboardingService',
    'SidebarService',
    'StudioService',
]))
    .component('userMenuReact', react2angular(UserMenuReact, ['user'], ['$translate']))
    .component('notificationsCenterReact', react2angular(NotificationsCenterReact, [], ['BlipService', '$translate']))
    .component('defaultHeader', DefaultHeaderComponent)
    .component('tenantsList', TenantsListComponent)
    .component('mainNavbar', MainNavbarComponent)
    .component('userMenu', UserMenuComponent)
    .directive('navbar', NavbarDirective.factory)
    .name;
